const formatOrdinal = (n: number): string => {
  if (n === 1) return '1ste';
  return `${n}de`;
};

export default formatOrdinal;
